module.exports = __webpack_public_path__ + "img/bulb-icon.d47d6980.svg";